let table = {

    init: function () {
        table.selector = 'table';
        table.elements = document.querySelectorAll(table.selector);
        table.attemptActionIfNotEmpty(table.ready);

        window.addEventListener('load', () => {
            table.attemptActionIfNotEmpty(table.loaded);
        });
    },

    attemptActionIfNotEmpty: function (action) {
        if (table.elements && table.elements.length > 0) {
            action();
        }
    },

    ready: function () {

        // set data-headline attribute to each cell
        table.elements.forEach(item => {
            const headlines = item.querySelectorAll('thead th');
            const rows = item.querySelectorAll('tbody tr');

            if(headlines.length === 0) {
                return;
            }

            rows.forEach(row => {
                const cells = row.querySelectorAll('td');
                const rowHeadline = row.querySelectorAll('th');
                let hasRowHealdine = false;

                if (rowHeadline.length > 0) {
                    hasRowHealdine = true;
                }

                cells.forEach((cell, index) => {

                    if (hasRowHealdine) {
                        index = index + 1;
                    }

                    cell.setAttribute('data-headline', headlines[index].innerText);
                });
            });

        });
    },

    loaded: function () {

    }
};

export default table.init();

